import { render } from "./MyListFolderOperation.vue?vue&type=template&id=ddddb9f2&scoped=true&ts=true"
import script from "./MyListFolderOperation.vue?vue&type=script&lang=ts"
export * from "./MyListFolderOperation.vue?vue&type=script&lang=ts"

import "./MyListFolderOperation.vue?vue&type=style&index=0&id=ddddb9f2&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddddb9f2"]])

export default __exports__